// socketManager.js – connection-only socket layer
import { io } from "socket.io-client";

let socket = null;

/* ------------------------------------------------------------------
   SERVER URL
------------------------------------------------------------------ */
const SOCKET_URL="https://metisel.com";
/**
 * Initialize socket ONCE per session
 */
export function initSocket(currentUser, setters = {}) {
  if (!currentUser) return () => {};

  // 🔒 PREVENT RE-CREATION
  if (socket) return () => {};

  const chatId =
    currentUser?.chatInfo?.[0]?.chatId ||
    currentUser?.chatId ||
    null;

  const {
    setUsers = () => {},
    setGroups = () => {},
    setOrderTimers = () => {},
    onUsersReady,   // ✅ ADDED
    onGroupsReady,  // (optional future use)
  } = setters;

  /* -------------------------------------------------------
     🔌 CREATE SOCKET
  ------------------------------------------------------- */
  socket = io(SOCKET_URL, {
  transports: ["websocket", "polling"],
  withCredentials: true,
  path: "/socket.io",
  reconnection: true,
  reconnectionAttempts: Infinity,
  reconnectionDelay: 1000,
  reconnectionDelayMax: 5000,
});
  /* -------------------------------------------------------
     🔌 CONNECT / RECONNECT
  ------------------------------------------------------- */
 socket.on("connect", () => {

  if (chatId) {
    socket.emit("user-online", { chatId });

    socket.emit("get-user-groups", chatId);
    socket.emit("get-users"); // 🔥 THIS FIXES YOUR ISSUE
    socket.emit("p2p:get-offers", { asset: "MTF" });
  }
});

  /* -------------------------------------------------------
     🔥 ERROR & DEBUG HANDLERS
  ------------------------------------------------------- */
  socket.on("connect_error", (err) => {
 
  });

  socket.on("disconnect", (reason) => {
  
  });

  socket.on("reconnect", (attempt) => {
  
  });

  socket.on("reconnect_error", (err) => {
 
  });

  /* -------------------------------------------------------
     🟦 USERS LIST (🔥 FIXED MERGE + READY SIGNAL)
  ------------------------------------------------------- */
  let usersReadySent = false;

  socket.on("users-list", (incomingUsers) => {

    setUsers((prev) => {
      const map = new Map(prev.map((u) => [String(u.chatId), u]));

      (incomingUsers || []).forEach((u) => {
        const existing = map.get(String(u.chatId));

        map.set(String(u.chatId), {
          ...u,
          lastMessage: existing?.lastMessage || u.lastMessage || null,
          lastActivityAt:
            existing?.lastActivityAt || u.lastActivityAt || null,
        });
      });

      return Array.from(map.values());
    });

    // ✅ SAFE READY TRIGGER
    if (!usersReadySent && typeof onUsersReady === "function") {
      usersReadySent = true;
      onUsersReady();
 
    }
  });

  return () => {};
}

/**
 * Explicit socket shutdown — call ONLY on logout.
 */
export function closeSocket(chatId) {
  if (!socket) return;

  try {
    if (chatId) socket.emit("user-offline", { chatId });
  } catch {}

  socket.disconnect();
  socket = null;
}

export function getSocket() {
  return socket;
}